import { Reveal, ChapterHead } from "./shared";

const REASONS = [
  { title: "Meaningful Design", text: "Seven colours, each with its own quiet symbolism.", testid: "reason-card-meaningful" },
  { title: "Handcrafted Character", text: "Shaped by hand — no two trees are ever alike.", testid: "reason-card-handcrafted" },
  { title: "Seven Crystal Stones", text: "Natural stone chips in white, purple, blue, green, yellow, orange and red.", testid: "reason-card-stones" },
  { title: "Versatile Décor", text: "At home on shelves, desks, corners and workspaces.", testid: "reason-card-versatile" },
  { title: "Thoughtful Gift", text: "A gift that carries colour, craft and intention.", testid: "reason-card-gift" },
];

const VALUES = [
  "Approximately 300 individual gemstone chips",
  "Handcrafted assembly",
  "Detailed wirework",
  "Seven-colour chakra arrangement",
  "Decorative wooden-style base",
  "Unique natural variation in gemstones",
  "Artistic craftsmanship",
  "A meaningful concept combined with home décor",
];

export default function Editorial() {
  return (
    <section className="py-20 lg:py-32" data-testid="editorial-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto mb-20">
          <Reveal>
            <p className="text-xs tracking-[0.28em] uppercase text-[#8C7A56]/80 mb-6" data-testid="editorial-eyebrow">
              Chapter 07 — Why People Choose It
            </p>
            <h2
              className="font-serif-display font-light tracking-tight leading-[1.12] text-[#1B1915] text-3xl sm:text-4xl lg:text-5xl"
              data-testid="editorial-title"
            >
              Designed To Be Seen.
              <br />
              <span className="italic text-[#C6A15B]">Made To Be Remembered.</span>
            </h2>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5 mb-24" data-testid="reasons-grid">
          {REASONS.map((r, i) => (
            <Reveal key={r.title} delay={i * 0.08}>
              <div
                className="group h-full p-7 border border-[#1B1915]/12 bg-white/50 rounded-sm text-center hover:-translate-y-1.5 hover:bg-white hover:border-[#C6A15B]/50 transition-[transform,background-color,border-color] duration-500"
                data-testid={r.testid}
              >
                <span className="font-serif-display italic text-2xl text-[#C6A15B]/70 block mb-4">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-serif-display text-lg text-[#1B1915] tracking-tight mb-2">{r.title}</h3>
                <p className="text-[13px] text-[#1A201C]/60 leading-relaxed">{r.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <ChapterHead
              number="08"
              label="Product Value"
              title="The Value Behind the Piece"
              testid="value"
            />
            <Reveal delay={0.15}>
              <p className="mt-8 text-base text-[#1A201C]/65 leading-relaxed" data-testid="value-intro">
                The value of the tree lies in what goes into it — natural material,
                patient handwork and a concept that carries meaning beyond decoration.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-x-10">
            {VALUES.map((v, i) => (
              <Reveal key={v} delay={(i % 2) * 0.08}>
                <div
                  className="flex items-start gap-4 py-5 border-b border-[#1B1915]/12"
                  data-testid={`value-item-${i + 1}`}
                >
                  <span className="font-serif-display italic text-lg text-[#C6A15B] shrink-0 w-7">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="text-sm sm:text-base text-[#1A201C]/75 leading-relaxed">{v}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
